import semver from 'semver';

// Hermes merge note: keep four-segment Hermes versions like 4.11.1.004
// semver-compatible by comparing only the upstream MAJOR.MINOR.PATCH triplet.
export const sanitizeVersion = version => {
  if (!version) return null;

  // Remove 'v' prefix if present
  const cleanVersion = version.toString().replace(/^v/, '');

  // Split by dots and keep only first 3 parts
  const parts = cleanVersion.split('.');
  if (parts.length <= 3) {
    return cleanVersion;
  }

  // If more than 3 parts (e.g., X.X.1.01), keep only first 3 (X.X.1)
  return parts.slice(0, 3).join('.');
};

export const hasAnUpdateAvailable = (latestVersion, currentVersion) => {
  const sanitizedLatest = sanitizeVersion(latestVersion);
  const sanitizedCurrent = sanitizeVersion(currentVersion);

  if (!semver.valid(sanitizedLatest) || !semver.valid(sanitizedCurrent)) {
    return false;
  }

  return semver.lt(sanitizedCurrent, sanitizedLatest);
};
